import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';
import {
  clearItineraryClosureReasons,
  getItineraryClosureReasons,
} from '../../../../actions/itinerary/ItineraryClosureReason';

export const ItineraryClosureReasonSelect = ({
  loading,
  itineraryClosureReasonOptions,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchGetItineraryClosureReasons,
  dispatchClearItineraryClosureReasons,
  ...rest
}) => {
  useEffect(() => {
    dispatchGetItineraryClosureReasons({
      ...DEFAULT_QUERY_GET_ALL,
    });

    return () => {
      dispatchClearItineraryClosureReasons();
    };
  }, [
    dispatchGetItineraryClosureReasons,
    dispatchClearItineraryClosureReasons,
  ]);

  const onInputChangeReason = (inputValue) => {
    const inputValueLength = inputValue.trim().length;

    if (inputValueLength >= 4) {
      dispatchGetItineraryClosureReasons({
        ...DEFAULT_QUERY_GET_ALL,
        query: [`reasonName:${inputValue}`],
      });
    }
  };

  return (
    <Select
      isLoading={loading}
      onInputChange={onInputChangeReason}
      options={itineraryClosureReasonOptions}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      {...rest}
    />
  );
};

ItineraryClosureReasonSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetItineraryClosureReasons: PropTypes.func.isRequired,
  dispatchClearItineraryClosureReasons: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  itineraryClosureReasonOptions: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

ItineraryClosureReasonSelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  itineraryClosureReasonOptions: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Busca por nombre',
};

const mapStateToProps = ({ ItineraryUnit }) => {
  const itineraryClosureReasons = ItineraryUnit.ItineraryClosureReason.getIn(
    ['all', 'content', 'content'],
    [],
  );

  return {
    itineraryClosureReasonOptions: itineraryClosureReasons.map((item) => ({
      value: item.id,
      label: item.reasonName,
    })),
    loading: ItineraryUnit.ItineraryClosureReason.getIn(
      ['all', 'loading'],
      false,
    ),
  };
};

const mapDispatchToProps = {
  dispatchGetItineraryClosureReasons: getItineraryClosureReasons,
  dispatchClearItineraryClosureReasons: clearItineraryClosureReasons,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItineraryClosureReasonSelect);
